import { render } from "./SystemScreen.vue?vue&type=template&id=725e023a"
import script from "./SystemScreen.vue?vue&type=script&lang=js"
export * from "./SystemScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__